import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
    interface Palette {
        cancel: Palette["primary"];
        delete: Palette["primary"];
        attention: Palette["primary"];
        weakBorder: string;
    }
    interface PaletteOptions {
        cancel?: PaletteOptions["primary"];
        delete?: PaletteOptions["primary"];
        attention?: PaletteOptions["primary"];
        weakBorder?: string;
    }
}

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#172b4d",
        },
        secondary: {
            main: "#799926",
        },
        success: {
            main: "#2e7d32",
        },
        error: {
            main: "#aa1d1d",
        },
        warning: {
            main: "#f59f00",
        },
        info: {
            main: "#73A9A0",
        },
        cancel: {
            main: "rgb(139 136 136)",
            contrastText: "#fff",
        },
        delete: {
            main: "#aa1d1d",
            contrastText: "#fff",
        },
        attention: {
            main: "#FFC0C1",
            contrastText: "#172b4d",
        },
        background: {
            default: "#f4f6f8",
            paper: "#ffffff",
        },
        text: {
            primary: "#172b4d",
        },
    },
    typography: {
        fontFamily: "Montserrat, sans-serif",
        fontSize: 12,
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                color: "inherit",
                elevation: 0,
            },
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    boxShadow: "none",
                    height: 64,

                    "& .MuiToolbar-root": {
                        padding: "0 1em",
                    },
                }),
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: ({ theme }) => ({
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,

                    "& .MuiDivider-root": {
                        borderColor: "rgba(255,255,255,0.12)",
                    },
                }),
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: ({ theme }) => ({
                    color: theme.palette.primary.contrastText,
                }),
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: 13,
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    minHeight: 64,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                sizeMedium: {
                    minHeight: "1.4375em",
                    padding: "8px 16px",
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: "small",
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: { borderRadius: 8 },
            },
        },
    },
});

export default theme;
